export const BASE_URL="https://uatpzcapi.p3z.in/api/";
export const WEBPHONE_URL = 'https://uatpzcwp.p3z.in/'
export const WEBSOCKETIO = 'https://uatpzcws.p3z.in/'
